import { render, staticRenderFns } from "./productInfo.vue?vue&type=template&id=f87b4be0&scoped=true"
import script from "./productInfo.vue?vue&type=script&lang=js"
export * from "./productInfo.vue?vue&type=script&lang=js"
import style0 from "./productInfo.vue?vue&type=style&index=0&id=f87b4be0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87b4be0",
  null
  
)

export default component.exports